{
  "actions": "الإجراءات"
}
